import { useState, useEffect, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { trackEvent } from '@fff-web/fff-analytics';
import { showWarningToast } from '@fff-web/fff-ui-shared/Toast';
import { getToastNotification, snoozeToastNotification } from '../services';
import { removeFirstReplaceSlashes, getTimestamp } from '../helpers/string';
import GlobalNavContext from '../context/globalNavContext';

const notificationKey = 'FFF_notification-id';
const CC_STATUS = 'expired';
export const clearToastUId = () => {
  window.localStorage.removeItem(notificationKey);
};

const useToast = () => {
  const [isToastOpen, setIsToastOpen] = useState(false);
  const globalNavContext = useContext(GlobalNavContext);
  const { env } = globalNavContext;

  const getLocation = () => {
    if (!window) {
      return '';
    }
    const location = removeFirstReplaceSlashes(window.location.pathname);
    return location || 'homepage';
  };

  const getUID = () => {
    let uid = '';
    if (window) {
      uid = window.localStorage.getItem(notificationKey);

      if (!uid) {
        uid = uuidv4();
        window.localStorage.setItem(notificationKey, uid);
      }
    }
    return uid;
  };

  useEffect(() => {
    getToastNotification(env, getLocation(), getUID())
      .then((data) => {
        if (data.firstUserVisualization === true) {
          trackEvent({
            ctaName: 'CC NavToast View',
            properties: {
              cc_status: CC_STATUS,
              url: window.location.pathname,
              timestamp: getTimestamp(),
            },
          });
        }
        const isSilenced = data.silenced;
        setIsToastOpen(!isSilenced);
        if (!isSilenced) {
          showWarningToast('Billing Information', data.htmlData.content);
        }
      })
      .catch((error) => {
        setIsToastOpen(false);
      });
  }, [env]);

  const snoozeToast = () => {
    snoozeToastNotification(env, getLocation(), getUID()).then((snoozed) => {
      if (snoozed) {
        setIsToastOpen(false);
        trackEvent({
          ctaName: 'CC NavToast Snooze',
          properties: {
            cc_status: CC_STATUS,
            snooze_attempt: 1,
            timestamp: getTimestamp(),
          },
        });
      }
    });
  };

  const closeToast = () => {
    setIsToastOpen(false);
  };

  return {
    isToastOpen,
    closeToast,
    snoozeToast,
    clearToastUId,
  };
};

export default useToast;
